<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <a href="/dashboard/map" class="btn btn-cyan"><i class="fa fa-arrow-circle-left"></i></a>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12"><h4 class="text-center"  style="font-size: 28px;">Cascade of services accessed by PWID  ({{ activeCity }}) Punjab</h4></div>
      <div class="col-md-7">

      <div id="container"  class="mt-5"></div>
      <div class="margin-top-minus-150">
        <div id="testedReactivePieChart"></div>
      </div>
    </div>
      <div class="col-md-5">
      <svg
        id="map2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="800 300 728 844"
        style="display: block"
      >
        <g
          class="model-green shadow filter-shaddow"
          id="Punjab"
          fill="#ffffd0"
          stroke="#d0c0a0"
          transform="translate(-27.1,-28.1)"
        >
          <a
            id="state_Vehari"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Vehari"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1123.8,847.1 3.6,2.6 7.6,-1.2 27.6,33 6,-0.4 8,-25.2 17.2,-5.6 12.6,3.8 15.4,-13.8 12.6,-0.8 3,-28 -8.6,-12.4 -35.6,22.8 -6.8,-6.4 -18.2,7.2 -6.6,11.2 -13.2,-5.4 -9.8,11.8 -11.4,1 z"
            />
          </a>
          <a
            id="state_Toba_Tek_Singh"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Toba Tek Singh"
            v-on:click="triggerChart(18)"
          >
            <path
              id="Toba_Tek_Singh"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['TTS']]"


              d="m 1219.8,762.3 -7.2,-3.4 2,-9.4 -5,-7.6 10,-12.8 -3.4,-8.4 9.4,-19.8 -4.8,-6.2 -16.2,10.8 -18.2,2.4 -23.2,36.8 8.4,12.8 -12.2,4.8 -5.2,13.8 40.8,-2 19.6,0.4 z"
            />
          </a>

          <a
            id="state_Sialkot"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Sialkot"
            v-on:click="triggerChart(34); return false;"
          >
            <path
              id="Sialkot"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['SKT']]"


              d="m 1381.6,541.9 3,-20.8 8.4,9.2 16.6,-11.4 -4.8,14 -1.6,14.4 6.4,12.4 12,-1.2 8,2.8 -6.8,9.2 -4,9.2 -8.6,8.4 1.4,8.4 -8.4,3 -3.4,8.2 -5.8,0.4 -6.8,-8.8 -9,-2.2 -11.6,-9.6 -3.8,-13.8 -3.8,-6.4 0,-11.4 13.2,-2.8 z"
            />
          </a>

          <a
            id="state_Shaikhupura"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Shaikhupura"
            v-on:click="triggerChart(35); return false;"

          >
            <path
              id="Shaikhupura"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['SKP']]"


              d="m 1368,660.3 -7.4,19.4 -9.8,10.6 -4.4,0.6 -1,-8.2 -6.6,-0.2 -0.8,-7 -22.6,-9.8 -2.8,-31.4 9.8,-10.2 8.2,-1 -2.4,11.2 25,-1.8 3.4,5.2 4.2,-6.6 18,-2.6 16,-15 -0.8,-5.4 5.8,-0.4 3.4,8 7.6,4.6 -19.4,22.8 -5.2,14.6 z"
            />
          </a>

          <a
            id="state_Sargodha"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Sargodha"
            v-on:click="triggerChart(30); return false;"
          >
            <path
              id="Sargodha"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['SGD']]"


              d="m 1221.4,636.9 11.4,-14.8 23.2,9.2 12.2,-22.2 -5.2,-14.2 -8.4,-1.4 -8.4,-10.2 3.4,-6.4 -6.2,-4.8 17.2,-9.6 0,-7.6 -60.6,15 -27.8,23 -11.6,53 13.4,4.4 -12.4,15.8 21.2,-10.6 10.8,-10.8 z"
            />
          </a>

          <a
            id="state_Sahiwal"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Sahiwal"
            v-on:click="triggerChart(22); return false;"
          >
            <path
              id="Sahiwal"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['SHW']]"


              d="m 1266.6,781.3 9.8,3.8 -0.8,-16.6 2.6,-8.6 -7,-5.4 -4.8,-12.6 -38.6,22.8 -8,-2.4 -5.2,12.2 -19.6,-0.4 -6.8,21.4 -1.8,20 6.8,6.4 35.6,-22.8 19.4,-2 z"
            />
          </a>

          <a
            id="state_Rawalpindi"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Rawalpindi"
            v-on:click="triggerChart(21); return false;"
          >
            <path
              id="Rawalpindi"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['RWP']]"
              d="m 1278,390.2 13.2,-6 8.6,35.9 -3,8.6 6.2,11.2 -6.2,17.8 6.6,17.8 -17.6,8.4 -9.8,-2.2 -3.2,11 -18.2,3.8 -11.8,3.2 -13.8,-11.2 -30,-7.6 8.8,-18.2 17.6,-11.6 -7.8,-18.2 -9,-2.8 3.6,-6.6 -8.2,-9.6 5.8,-5.2 3.8,3.2 12,-3 -5.2,4.8 10.8,4.2 -11.8,3.6 6.4,13.8 18,-8.8 6.8,10.2 -3.8,3 6,4.8 11.2,-7.2 1.6,-9 7.8,-7.8 -3.2,-4.2 -2.8,0.2 -10.6,-7.8 16.6,-9.2 z"
            />
          </a>

          <a
            id="state_Rajanpur"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Rajanpur"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 972.2,870.9 -17.8,-3.2 -10.4,21 3.4,27.4 -13,26.6 -9.2,10.8 1.6,20.4 -14.4,23.2 -6.6,1 5.8,23.4 36.8,-15.2 0,-19.6 14.4,2.8 17.4,-10.2 -4.4,-12.2 15.8,-2.8 7.4,-23.8 -5,-6.8 15,-30.8 1.6,-23.4 -11.6,-8.6 -14.6,18.2 z"
            />
          </a>

          <a
            id="state_Rahimyar_Khan"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Rahimyar Khan"
            v-on:click="triggerChart(19); return false;"
          >
            <path
              id="Rahimyar_Khan"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['RYK']]"


              d="m 1020.4,944.3 -3,11.8 -25.8,8.2 -15.8,2.8 4.4,12.2 -17.4,10.2 -14.4,-2.8 0,19.6 -36.8,15.2 11.6,16.8 6.2,24.6 13,17.8 18,8.4 16,-14.4 19.6,-1.2 11,12 3.2,13.2 5.4,9.6 12.8,1.2 35.8,-16.4 -27.2,-89.8 11,-53.8 -8.4,4 -5.4,-18.6 z"
            />
          </a>

          <a
            id="state_Pakpattan"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Pakpattan"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1266.6,781.3 -18.4,15.8 -19.4,2 8.6,12.4 -3,28 10.8,4.4 4.6,-8 30.2,-10 26.2,-18.4 -1,-20.6 -18.2,-11.8 -10.6,10 z"
            />
          </a>

          <a
            id="state_Okara"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Okara"
            v-on:click="triggerChart(24); return false;"
          >
            <path
              id="Okara"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['OKR']]"
              d="m 1278.2,759.9 -2.6,8.6 0.8,16.6 10.6,-10 18.2,11.8 1,20.6 21.2,-3.4 5.6,-11.2 10.8,-8.8 3.8,1.6 2.2,-10 13.2,-12.8 -14,-3.8 -10.8,-9.6 -12.6,-1.8 -17.8,-21.2 0,-10.8 -16.8,6 -12.4,11.8 -4.4,-0.4 -7.8,8.8 4.8,12.6 z"
            />
          </a>

          <a
            id="state_Narowal"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Narowal"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1422.8,570.5 6.8,-9.2 7.4,2.8 7.8,-5.2 7.8,8.2 6,-0.4 12.4,9.2 7,9.6 -14.8,20.4 -2.2,-4 -21.4,10.4 -6.6,-3.6 -13,13 -9.2,-1.4 -7.6,-4.6 -3.4,-8 3.4,-8.2 8.4,-3 -1.4,-8.4 8.6,-8.4 z"
            />
          </a>

          <a
            id="state_Nankana_Sahab"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Nankana_Sahab"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1285,665.1 8,20.8 8.6,-3.8 8.6,8.8 -4,10.2 -20.8,13.8 -10,9.6 -1.2,8.6 4.4,0.4 12.4,-11.8 16.8,-6 9.2,-5.4 12,-3 5.4,-5.6 9.6,-2.4 2.4,-8.4 -1,-8.2 -6.6,-0.2 -0.8,-7 -22.6,-9.8 -2.8,-31.4 -13.2,1.8 -8.6,6.2 -22.4,7.8 z"
            />
          </a>

          <a
            id="state_Muzaffargarh"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(12)"
            data-toggle="tooltip"
            data-html="true"
            title="Muzaffargarh"
          >
            <path
              id="Muzaffargarh"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['MFG']]"
              d="m 1010.6,879.5 -1.6,23.4 -15,30.8 5,6.8 -7.4,23.8 25.8,-8.2 3,-11.8 13.8,-9.4 13.8,-25 0.8,-24.8 13.4,-6.6 -1.6,-27 30,-54 -6.4,-2 8.6,-17.4 -33.4,-21 -7,12.8 -32.6,1.6 3.8,25 -4,24.4 6.4,33 z"
            />
          </a>

          <a
            id="state_Multan"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(10)"
            data-toggle="tooltip"
            data-html="true"
            title="Multan"
          >
            <path
              id="Multan"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['MUL']]"
              d="m 1067.6,904.3 12.8,6.4 5.4,-41.2 21.8,-25.6 16.6,-27.6 -33.6,-18.8 -30,54 1.6,27 -13.4,6.6 -0.8,24.8 z"
            />
          </a>

          <a
            id="state_Mianwali"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Mianwali"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1127,556.1 -11.6,10.4 4,7.6 -9.2,12.8 1,10.8 -58.8,1 11,-21.8 10,-3.8 0.6,-18.8 -9.6,3.6 0.2,-10.6 -7.6,0 -6.4,-19 3.6,-19.6 12.8,-8 15.2,-1.6 2.2,-7.4 -6.2,-18.4 18.4,2.2 4.8,12.6 10.8,4.6 -3.6,12.8 10.8,-2.2 12,19.8 -6.8,9.8 z"
            />
          </a>

          <a
            id="state_Mandi_Bahauddin"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Mandi_Bahauddin"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1293.2,588.5 -9.6,13.2 -15.4,7.4 -5.2,-14.2 -8.4,-1.4 -8.4,-10.2 3.4,-6.4 -6.2,-4.8 17.2,-9.6 0,-7.6 9.2,-4.2 5.4,3 20,-12.8 3.4,-5.8 29.2,36 -17.6,9.6 z"
            />
          </a>

          <a
            id="state_Lodhran"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Lodhran"
            v-on:click="triggerChart(16)"
          >
            <path
              id="Lodhran"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['LOD']]"
              d="m 1094.4,913.5 68.2,-32 -27.6,-33 -7.6,1.2 -3.6,-2.6 -16.2,-3.2 -21.8,25.6 -5.4,41.2 z"
            />
          </a>

          <a
            id="state_Layyah"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Layyah"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1120.6,739.5 -4.6,-28.6 -19.2,-8.2 -10.2,10.4 -14,1 -13.4,-21.6 -35.2,-7.6 -7.6,14.4 2.4,46.8 -4.2,9.2 5.2,16.2 32.6,-1.6 7,-12.8 33.4,21 3.6,6 6,-14 z"
            />
          </a>

          <a
            id="state_Lahore"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Lahore"
            v-on:click="triggerChart(29); return false;"
          >
            <path
              id="Lahore"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['LHR']]"
              d="m 1346.4,690.9 4.4,-0.6 9.8,-10.6 7.4,-19.4 18.2,-2.6 5.2,-14.6 12.4,34 -9,19.6 -8.2,-2 -2.6,4.6 -18.2,6 -21.8,-6 z"
            />
          </a>

          <a
            id="state_Khushab"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Khushab"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1172.2,592.9 27.8,-23 -2,-15 -11.2,-13.2 -11.2,6.6 -24.6,-11.6 -4,8.4 -20,11 -11.6,10.4 4,7.6 -9.2,12.8 1,10.8 1.6,16 -14.6,19.8 13.2,21.2 24.6,18 16.8,-22.6 7.8,-4.2 z"
            />
          </a>

          <a
            id="state_Khanewal"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Khanewal"
            v-on:click="triggerChart(9)"
          >
            <path
              id="Khanewal"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['KNW']]"
              d="m 1107.6,843.9 16.2,3.2 3.4,-5.8 11.4,-1 9.8,-11.8 13.2,5.4 6.6,-11.2 18.2,-7.2 1.8,-20 6.8,-21.4 -40.8,2 5.2,-13.8 -43.6,13.8 -13.4,-6 -6,14 -3.6,-6 -8.6,17.4 6.4,2 33.6,18.8 z"
            />
          </a>

          <a
            id="state_Kasur"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Kasur"
            v-on:click="triggerChart(15)"
          >
            <path
              id="Kasur"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['KAS']]"


              d="m 1344,699.3 21.8,6 18.2,-6 2.6,-4.6 8.2,2 -0.4,18.6 11.8,3 2.4,4.8 -4.8,5 -8.6,-4.8 -0.6,8.2 -18.2,12.2 -13.4,19.2 -14,-3.8 -10.8,-9.6 -12.6,-1.8 -17.8,-21.2 0,-10.8 9.2,-5.4 12,-3 5.4,-5.6 z"
            />
          </a>

          <a
            id="state_Jhelum"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Jhelum"
            v-on:click="triggerChart(17)"
          >
            <path
              id="Jhelum"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['JHL']]"


              d="m 1252.8,539.3 10.2,-0.4 -4,-7.6 -10.2,-1.4 -1.2,-7 8.4,-10 -1.4,-16.4 18.2,-3.8 3.2,-11 9.8,2.2 17.6,-8.4 2.6,7 -3.2,7.2 17.6,9.8 -1,6.4 -19.2,20.8 -1.6,8.4 -3.4,5.8 -20,12.8 -5.4,-3 -9.2,4.2 -60.6,15 -2,-15 7,-4.2 3,5 5.8,-8 25,-4.8 5.4,1.4 z"
            />
          </a>

          <a
            id="state_Jhang"
            class="state"
            xlink:href="javascript:void(0);"
            data-toggle="tooltip"
            data-html="true"
            title="Jhang"
            v-on:click="triggerChart(23); return false;"
          >
            <path
              id="Jhang"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['JNG']]"
              d="m 1159.4,762.3 12.2,-4.8 -8.4,-12.8 23.2,-36.8 18.2,-2.4 16.2,-10.8 -1.2,-5.8 -8.8,4 -22.4,-14.8 -5.6,-22.6 -21.2,10.6 12.4,-15.8 -13.4,-4.4 -7.8,4.2 -16.8,22.6 -0.4,30 -10.6,-1.8 -9,10 4.6,28.6 -18.2,30.6 13.4,6 z"
            />
          </a>

          <a
            id="state_Hafizabad"
            class="state"
            xlink:href="javascript:void(0);"
            v-on:click="triggerChart(44)"
            data-toggle="tooltip"
            data-html="true"
            title="Hafizabad"
          >
            <path
              id="Hafizabad"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['HFZ']]"


              d="m 1290.8,642.3 -22.4,7.8 -8,-6.6 -4.4,-12.2 12.2,-22.2 15.4,-7.4 9.6,-13.2 17,-7.8 4.2,13.2 7.8,9.4 3.6,12 -3.4,8.8 -9.8,10.2 -13.2,1.8 z"
            />
          </a>

          <a
            id="state_Gujranwala"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            data-toggle="tooltip"
            data-html="true"
            title="Gujranwala"
            v-on:click="triggerChart(33); return false;"
          >
            <path
              id="Gujranwala"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['GRW']]"


              d="m 1359,567.3 3.8,6.4 3.8,13.8 11.6,9.6 9,2.2 6.8,8.8 0.8,5.4 -16,15 -18,2.6 -4.2,6.6 -3.4,-5.2 -25,1.8 2.4,-11.2 -8.2,1 3.4,-8.8 -3.6,-12 -7.8,-9.4 -4.2,-13.2 17.6,-9.6 11,0.6 20.2,-15.8 z"
            />
          </a>

          <a
            id="state_Gujrat"
            class="state"
            data-toggle="tooltip"
            data-html="true"
            title="Gujrat"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(14)"
          >
            <path
              id="Gujrat"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['GUJ']]"


              d="m 1327.8,571.1 -29.2,-36 1.6,-8.4 19.2,-20.8 1,-6.4 11.6,-3 9,10 30.8,15 12.8,-0.4 -3,20.8 -9.4,11.2 -13.2,2.8 -20.2,15.8 z"
            />
          </a>

          <a
            id="state_Faisalabad"
            class="state"
            xlink:href="javascript:void(0);"
            v-on:click="triggerChart(31); return false;"
            data-toggle="tooltip"
            data-html="true"
            title="Faisalabad"

          >
            <path
              id="Faisalabad"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['FSD']]"


              d="m 1216.2,720.7 3.4,8.4 -10,12.8 5,7.6 -2,9.4 7.2,3.4 8,2.4 38.6,-22.8 7.8,-8.8 1.2,-8.6 10,-9.6 20.8,-13.8 4,-10.2 -8.6,-8.8 -8.6,3.8 -8,-20.8 -16.6,-15 -8,-6.6 -40.8,45.4 1.2,5.8 4.8,6.2 z"
            />
          </a>

          <a
            id="state_Dera_Ghazi_Khan"
            class="state"
            xlink:href="javascript:void(0);"
            v-on:click="triggerChart(32); return false;"
            data-toggle="tooltip"
            data-html="true"
            title="Dera Ghazi Khan"
          >
            <path
              id="Dera_Ghazi_Khan"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['DGK']]"
              d="m 979,705.5 -13.4,6.4 0.6,10 -3,0.4 -1.2,23.4 2.2,6.2 -6.2,0.8 -12,13.2 1,9.2 -10.6,20.8 -4.2,17.4 3.6,7 9.6,-3.8 -7.6,15.2 -8.2,23.8 -15.6,22.8 -13.4,5.4 -4.2,26.8 10.6,3.4 -2.2,7 4.8,6.6 5.4,-3 -4.6,24 -21,21.8 3.8,10.8 -8.6,20.2 -11.2,6.4 5,12 9.6,-4.4 23.6,6.2 -5.8,-23.4 6.6,-1 14.4,-23.2 -1.6,-20.4 9.2,-10.8 13,-26.6 -3.4,-27.4 10.4,-21 17.8,3.2 12.2,18.2 14.6,-18.2 11.6,8.6 15.4,-25.6 -6.4,-33 4,-24.4 -3.8,-25 -5.2,-16.2 4.2,-9.2 -2.4,-46.8 -7.2,-6 -13.6,-1.6 z"
            />
          </a>

          <a
            id="state_Chiniot"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Chiniot"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1221.4,636.9 -27.8,7.8 -10.8,10.8 5.6,22.6 22.4,14.8 8.8,-4 40.8,-45.4 -4.4,-12.2 -23.2,-9.2 z"
            />
          </a>

          <a
            id="state_Chakwal"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Chakwal"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1184.2,490.5 -23.2,2 -5.2,-4 -6.4,5.6 -7.2,-2.6 -22.8,11.8 12,19.8 -6.8,9.8 2.4,23.2 20,-11 4,-8.4 24.6,11.6 11.2,-6.6 11.2,13.2 7,-4.2 3,5 5.8,-8 25,-4.8 5.4,1.4 8.6,-5 10.2,-0.4 -4,-7.6 -10.2,-1.4 -1.2,-7 8.4,-10 -1.4,-16.4 -11.8,3.2 -13.8,-11.2 -30,-7.6 -6.6,-1.6 z"
            />
          </a>

          <a
            id="state_Bhakkar"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Bhakkar"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1135.6,702.7 0.4,-30 -24.6,-18 -13.2,-21.2 14.6,-19.8 -1.6,-16 -58.8,1 -9.8,30.6 -15.8,23.2 -4.4,16.6 6,1 -4.4,14.8 35.2,7.6 13.4,21.6 14,-1 10.2,-10.4 19.2,8.2 9,-10 z"
            />
          </a>

          <a
            id="state_Bahawalpur"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(11)"
            data-toggle="tooltip"
            title="Bahawalpur"
          >
            <path
              id="Bahawalpur"
              class="shape"
              stroke="#FFF"
              stroke-width="1"


              :class="[citiesColors['BHP']]"
              d="m 1168.6,881.1 -6,0.4 -68.2,32 -14,-2.8 -12.8,-6.4 -19.6,5.6 -13.8,25 5.4,18.6 8.4,-4 -11,53.8 27.2,89.8 50.2,-7 15.4,-6.2 2.2,-17.4 26.2,-28 11.8,-35.2 9.4,-12.8 20.8,-11.6 -8,-25.8 -12.6,0 -3.6,-12.6 6,-5.8 39.8,0 4.2,-13.8 -12,-7 8.4,-27.2 -15.8,-17 -0.2,-11.6 -12.6,-3.8 -17.2,5.6 z"
            />
          </a>

          <a
            id="state_Bahawalnagar"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
            v-on:click="triggerChart(13)"
            data-toggle="tooltip"
            data-html="true"
            title="Bahawalnagar"
          >
            <path
              id="Bahawalnagar"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              :class="[citiesColors['BHG']]"
              d="m 1280,825.9 -30.2,10 -4.6,8 -10.8,-4.4 -12.6,0.8 -15.4,13.8 0.2,11.6 15.8,17 -8.4,27.2 12,7 -4.2,13.8 -39.8,0 -6,5.8 3.6,12.6 12.6,0 8,25.8 34.6,-19.6 30.8,-55.2 13.8,-47.4 40.8,-15.2 16.2,-13.8 -2.2,-13.2 -6.8,-6.4 -21.2,3.4 z"
            />
          </a>

          <a
            id="state_Attock"
            class="state"
            xlink:href="javascript:void(0);"
            onclick=""
          >
            <path
              id="Attock"
              class="shape"
              stroke="#FFF"
              stroke-width="1"
              d="m 1207.8,462.7 -8.8,18.2 -6.6,-1.6 -8.2,11.2 -23.2,2 -5.2,-4 -6.4,5.6 -7.2,-2.6 -22.8,11.8 -10.8,2.2 3.6,-12.8 4.2,-12.8 -5.6,-10.4 2.4,-9.4 14,-6.4 9.2,-14 7.8,-25.2 21,-2.2 0,-18.7 20.4,-9.4 17.2,9.4 -2.6,5.4 7.2,2.5 7,-7.3 8.6,5.8 2.6,8.9 -12,3 -3.8,-3.2 -5.8,5.2 8.2,9.6 -3.6,6.6 9,2.8 7.8,18.2 z"
            />
          </a>

          <path
            id="Punjab_Border"
            fill="none"
            stroke="#a08070"
            d="m 1303,439.9 -6.2,-11.2 3,-8.6 -8.6,-35.9 -13.2,6 -4.6,9.3 -16.6,9.2 10.6,7.8 2.8,-0.2 3.2,4.2 -7.8,7.8 -1.6,9 -11.2,7.2 -6,-4.8 3.8,-3 -6.8,-10.2 -18,8.8 -6.4,-13.8 11.8,-3.6 -10.8,-4.2 5.2,-4.8 -2.6,-8.9 -8.6,-5.8 -7,7.3 -7.2,-2.5 2.6,-5.4 -17.2,-9.4 -20.4,9.4 0,18.7 -21,2.2 -7.8,25.2 -9.2,14 -14,6.4 -2.4,9.4 5.6,10.4 -4.2,12.8 -10.8,-4.6 -4.8,-12.6 -18.4,-2.2 6.2,18.4 -2.2,7.4 -15.2,1.6 -12.8,8 -3.6,19.6 6.4,19 7.6,0 -0.2,10.6 9.6,-3.6 -0.6,18.8 -10,3.8 -11,21.8 -9.8,30.6 -15.8,23.2 -4.4,16.6 6,1 -4.4,14.8 -7.6,14.4 -7.2,-6 -13.6,-1.6 -16.6,13.8 -13.4,6.4 0.6,10 -3,0.4 -1.2,23.4 2.2,6.2 -6.2,0.8 -12,13.2 1,9.2 -10.6,20.8 -4.2,17.4 3.6,7 9.6,-3.8 -7.6,15.2 -8.2,23.8 -15.6,22.8 -13.4,5.4 -4.2,26.8 10.6,3.4 -2.2,7 4.8,6.6 5.4,-3 -4.6,24 -21,21.8 3.8,10.8 -8.6,20.2 -11.2,6.4 5,12 9.6,-4.4 23.6,6.2 11.6,16.8 6.2,24.6 13,17.8 18,8.4 16,-14.4 19.6,-1.2 11,12 3.2,13.2 5.4,9.6 12.8,1.2 35.8,-16.4 50.2,-7 15.4,-6.2 2.2,-17.4 26.2,-28 11.8,-35.2 9.4,-12.8 20.8,-11.6 34.6,-19.6 30.8,-55.2 13.8,-47.4 40.8,-15.2 16.2,-13.8 -2.2,-13.2 -6.8,-6.4 5.6,-11.2 10.8,-8.8 3.8,1.6 2.2,-10 13.2,-12.8 13.4,-19.2 18.2,-12.2 0.6,-8.2 8.6,4.8 4.8,-5 -2.4,-4.8 -11.8,-3 0.4,-18.6 9,-19.6 -12.4,-34 19.4,-22.8 9.2,1.4 13,-13 6.6,3.6 21.4,-10.4 2.2,4 14.8,-20.4 -7,-9.6 -12.4,-9.2 -6,0.4 -7.8,-8.2 -7.8,5.2 -7.4,-2.8 -8,-2.8 -12,1.2 -6.4,-12.4 1.6,-14.4 4.8,-14 -16.6,11.4 -8.4,-9.2 -12.8,0.4 -30.8,-15 -9,-10 -11.6,3 -17.6,-9.8 3.2,-7.2 -2.6,-7 -6.6,-17.8 z"
          />
        </g>
  <g
            id="Labels"
            font-size="10"
            font-family="DejaVu Sans"
            transform="translate(-27.1,-28.1)"
          >
            <text y="1034.8398" x="944.83813">RAHIM YAR KHAN</text>
            <text y="852.76074" x="1079.0706">• MULTAN</text>
            <text y="788.75977" x="1204.928">SAHIWAL</text>
            <text y="800.25977" x="1117.8713">KHANEWAL</text>
            <text y="766.84277" x="1294.844">OKARA</text>
            <text y="706.75879" x="1230.5881">FAISALABAD</text>
            <!-- <text y="679.79395" x="1231.2582">NAKANA SAHAB •</text> -->
            <text y="654.79297" x="1343.3733">• SHAIKHUPURA</text>
            <text y="599.49219" x="1275.1819">GUJRANWALA •</text>
            <text y="538.46094" x="1322.6311">GUJRAT</text>
            <text y="575.12598" x="1370.1799">SIALKOT</text>
            <!-- <text y="592.45996" x="1417.3508">NAROWAL</text> -->
            <text y="623.12598" x="1265.9055">HAFIZABAD</text>
            <!-- <text y="573.46289" x="1190.178">MANDI BAHAUDDIN •</text> -->
            <text y="680.88281" x="1377.5959">• LAHORE</text>
            <text y="730.09277" x="1337.5393">KASUR</text>
            <text y="699.42773" x="1149.1526">JHANG</text>
            <!-- <text y="658.76172" x="1200.8772">CHINIOT</text> -->
            <text y="610.76172" x="1186.8147">SARGODHA</text>
            <text y="751.4082" x="1106.1428">TOBA TEK SINGH •</text>
            <text y="882.09375" x="1092.3186">LODHRAN</text>
            <text y="974.3457" x="1085.092">BAHAWALPUR</text>
            <text y="904.82227" x="1151.7288">BAHAWALNAGAR •</text>
            <!-- <text y="955.50684" x="937.28442">RAJANPUR</text> -->
            <text y="792.50684" x="977.92017">• DERA GHAZI KHAN</text>
            <!-- <text y="844.75977" x="1166.1506">VEHARI</text> -->
            <!-- <text y="810.75977" x="1239.0375">PAKPATTAN</text> -->
            <text y="842.42773" x="959.29517">MUZAFFARGARH •</text>
            <text y="470.09277" x="1224.9846">RAWALPINDI</text>
            <text y="512.76172" x="1264.0969">JHELUM</text>
          </g>

      </svg>
      <div class="positive-ratio-colors"  v-on:click="triggerChart(45)">
        <span
          type="button"
          class="text-bold"
          style="width:70px; font-size: 10px; margin-bottom: 1px; text-align: center;"
        >
          HIV positivity rate
        </span>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(245, 183, 177); width:70px; font-size: 10px;"
        >
          < 20%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(255 141 129); width:70px; font-size: 10px;"
        >
          21-40%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(228 94 80); width:70px; font-size: 10px;"
        >
          41-60%
        </button>
        <br />
        <button
          type="button"
          class="btn btn-default text-white text-bold btn-ratio"
          style="background: rgb(226, 23, 23); width:70px; font-size: 10px;"
        >
           60% +
        </button>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import PunjabIndicators from "../indicators/PunjabIndicators.vue";
export default {
    name : 'punjab-map',
    components: { PunjabIndicators },
    data() {
    return {
      citiesColors: [],
      loader: true,
      chart: null,
      chartSpouse: null,
      isClient: true,
      tested: null,
      reactive: null,
      tableDataCities: null,
      citySpots: 0,
      activeCity : 'Overall',
    };
  },
  methods: {
    async callPositivePWID() {
      await axios
        .get("prevalenceHtc")
        .then((response) => {
          if (response.status == 200) {
            this.citiesColors = response.data;
            loader = false;
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    async callPWID() {
      var dataSeries = [];
      var column = {
        data: [],
      };
      await axios
        .get("byCitiesPWIDPunjab")
        .then((response) => {
          response.data.forEach((data) => {
            column.name = data.CityShortName;
            if (column.name == "AllPunjab") {
              column.visible = true;
              column.color = "#287161";
            } else {
              column.visible = false;
              column.color = "#287161";
            }
            column.data.push(parseInt(data.ActiveCases));
            column.data.push(parseInt(data.DistinctVCCT));
            column.data.push(parseInt(data.Reactive));
            column.data.push(parseInt(data.RegART));
            column.data.push(parseInt(data.OnART));
            column.data.push(parseInt(data.CompletedAAU));
            column.data.push(parseInt(data.Adherent));
            // column.data.push(parseInt(data.ViralLoadTested));
            // column.data.push(parseInt(data.ViralLoadSuppressed));


            dataSeries.push(column);
            column = {
              data: [],
            };
          });
          dataSeries.forEach(this.colorizeData);
          this.chart = Highcharts.chart("container", {
            chart: {
              type: "column",
              animation: true,
              style: {
                fontFamily: 'Ubuntu',
                fontWeight: '700'
              }

            },
            title: {
              text: "",
            },
            xAxis: {
              categories: [
                "Active<br>Cases",
                "Tested",
                "Reactive",
                "ART<br>Registered",
                "On<br>ART",
                "Completed<br>AAU",
                "Adherent",
                // "ViralLoad<br>Tested",
                // "VL<br>Supressed",
              ],
              labels : {
                useHTML : true,
                style : {
                  fontSize: '10px',
                  wordBreak: 'break-all',
                  fontWeight: '700',
                  fontFamily: 'Ubuntu',
                }
              },
              crosshair: true,
            },
            yAxis: {
              stackLabels: {
                style: {
                    fontSize: '2px',
                },
                enabled: false,
              },
              min: 0,
              title: {
                text: "Number of PWID",
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat:
                '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
              footerFormat: "</table>",
              shared: true,
              useHTML: true,
            },
            plotOptions: {
              column: {
                pointPadding: 0.1,
                borderWidth: 0,
              },
              color: {
                radialGradient: { cx: 0.5, cy: 0.5, r: 0.5 },
                stops: [
                  [0, "#003399"],
                  [1, "#3366AA"],
                ],
              },
              series: {
                 pointPadding: 0,
                groupPadding: 0,
                point: {
                  events: {
                    click: function(){
                    }
                  }
                },
                dataLabels: {
                  enabled: true,
                  style: {
                      fontSize: '10px',
                      fontWeight: '700',
                      fontFamily: 'Ubuntu',
                  },
                  formatter: function() {
                      return Number(this.y).toLocaleString();
                      // return this.y + '<br>' + this.x
                  }
                }
              },
            },
            credits: {
              enabled: false,
            },
            legend: {
                enabled: false
            },
            series: dataSeries,
          });
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    async callPWIDPositiveTested(){
      await axios
        .get("pwidReactiveTestedPunjab")
        .then((response) => {
          if (response.status == 200) {
            this.tableDataCities = response.data;
            this.populatePieCharts('All');
          }
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loader = false));
    },
    populatePieCharts(city){
      var testedReactiveData = [{
        name : 'Reactive',
        y : parseInt(this.tableDataCities[city].Reactive)
      }, {
        name : 'Non reactive',
        y : parseInt(this.tableDataCities[city].DistinctVCCT) - parseInt(this.tableDataCities[city].Reactive)
      }];

      var genderData = [{
        name : 'Male',
        y : parseInt(this.tableDataCities[city].Male)
      }, {
        name : 'Female',
        y : parseInt(this.tableDataCities[city].Female)
      }];

      var ageData = [{
        name : 'Age > 25',
        y : parseInt(this.tableDataCities[city].Male25Greater)
      }, {
        name : 'Age < 25',
        y : parseInt(this.tableDataCities[city].Male25Less)
      }];

      this.populateTestedReactiveGender(testedReactiveData, genderData, ageData);
    },
    populateTestedReactiveGender(testedreactive, genders, ages){
      var chart = Highcharts.chart('testedReactivePieChart', {
          chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie',
              style: {
                fontFamily: 'Ubuntu',
                fontWeight: '700'
              }
          },
          title: {
              text: '',
              style : {
                'fontSize' : '12px'
              }
          },
          tooltip: {
              enabled : false,
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          accessibility: {
              point: {
                  valueSuffix: '%'
              }
          },
          plotOptions: {
              pie: {
                  shadow: false,
                  size: 150,
                  allowPointSelect: false,
                  cursor: 'pointer',
                  colors: ['#198754', '#dc3545'],
                  dataLabels: {
                      distance: 10,
                      enabled: true,
                      style : {
                        fontSize: '10px',
                        fontWeight: '700'
                      },
                      format: '<b>{point.name}</b>:{point.percentage:.1f}%'
                  }
              }
          },
          credits: {
              enabled: false,
          },
          series: [{
              name: 'PWIDs',
              center: [180, 100],
              colorByPoint: true,
              colors: ['#dc3545', '#198754'],
              data: testedreactive,
              shadow: true
          },
          {
              name: 'PWIDs',
              center: [480, 100],
              colorByPoint: true,
              colors: [ '#17a2b8', '#ffc107'],
              data: ages
          }],
      });
      return false;
    },
    triggerChart(x) {
      this.loader = true
      this.activeCity = this.chart.series[x].name;
      $(this.chart.series).each(function (i, e) {
        e.hide();
      });
      this.chart.series[x].show()
      this.populatePieCharts(this.chart.series[x].name);
      this.loader = false
    },
    colorizeData(data) {
      data.color = {
          radialGradient: {cx: 0.5, cy: 0.3, r: 0.7},
          stops: [
              [0, data.color],
              [1, Highcharts.Color(data.color).brighten(-0.3).get('rgb')] // darken
          ]
      };
    }
  },
  mounted() {
    this.callPositivePWID();
    this.callPWIDPositiveTested();
    this.callPWID();


  },
};
</script>

<style lang="scss" scoped>
.filter-shaddow {
    filter: drop-shadow(9px 4px 5px rgb(79 79 79 / 93%));
}
#populatePieCharts{
  height: 200px;
}
#container {
  height: 300px;
  // -webkit-box-shadow: -1px 4px 16px -5px rgba(0,0,0,0.93);
  // box-shadow: -1px 4px 16px -11px rgb(0 0 0 / 76%)
}
#containerSpouse {
  height: 500px;
}
.margin-top-minus-150{
  margin-top: -100;
}
.shadow {
  // -webkit-filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  // filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  // /* Similar syntax to box-shadow */
  -webkit-box-shadow: -1px 4px 16px -5px rgba(0, 0, 0, 0.93);
  box-shadow: -1px 4px 16px -5px rgba(0, 0, 0, 0.93);
}
#map2 {
  display: none;
}

#map2 .state {
  cursor: pointer;
}

#map2 .state .shape {
  cursor: pointer;
  -width: 0;
}

#map2 .state .label_icon_state {
  fill: #fff;
  font-family: Arial;
  font-size: 11px;
  line-height: 12px;
  font-weight: normal;
}

#map2 .state .label_state {
  display: none;
  font-family: Arial;
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
}

#map2 .state:hover .label_state,
#map2 .state.hover .label_state {
  display: block;
}

#map2 .model-green .state .shape {
  fill: #e6e6e6;
}

#map2 .model-green .state .icon_state {
  fill: #05110a;
}

#map2 .model-green .state .label_icon_state {
  fill: #fff;
}

#map2 .model-green .state .label_state {
  fill: #666;
}

#map2 .model-green .state:hover .shape,
#map2 .model-green .state.hover .shape {
  fill: #9c9c9c;
}

#map2 .model-green .state:hover .icon_state,
#map2 .model-green .state.hover .icon_state {
  fill: #9c9c9c;
}

#map2 .model-orange .state .shape {
  fill: #fd7132;
}

#map2 .model-orange .state .icon_state {
  fill: #6cb361;
}

#map2 .model-orange .state .label_icon_state {
  fill: #fff;
}

#map2 .model-orange .state .label_state {
  fill: #666;
}

#map2 .model-orange .state:hover .shape,
#map2 .model-orange .state.hover .shape {
  fill: #c93f04;
}

#map2 .model-orange .state:hover .icon_state,
#map2 .model-orange .state.hover .icon_state {
  fill: #10592f;
}

#map2 .model-darkgreen .state .shape {
  fill: #366823;
}

#map2 .model-darkgreen .state .icon_state {
  fill: #2779c6;
}

#map2 .model-darkgreen .state .label_icon_state {
  fill: #fff;
}

#map2 .model-darkgreen .state .label_state {
  fill: #666;
}

#map2 .model-darkgreen .state:hover .shape,
#map2 .model-darkgreen .state.hover .shape {
  fill: #4a8c31;
}

#map2 .model-darkgreen .state:hover .icon_state,
#map2 .model-darkgreen .state.hover .icon_state {
  fill: #5a95ce;
}
.class0-20 {
  fill: rgb(245, 183, 177) !important;
}
.class20-40 {
  fill: rgb(255 141 129) !important;
}
.class40-60 {
  fill: rgb(228 94 80) !important;
}
.class60-100 {
  fill: rgb(226, 23, 23) !important;
}
.class100 {
  fill: #afafaf !important;
}
.text {
  fill: #fff !important;
}
.positive-ratio-colors {
  position: absolute;
  top: 50%;
  right: 80px;
}
text {
  fill: #fff !important;
  font-size: 10px;
  text-shadow: 2px 3px 6px #000;
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
